import "./CqlNarcId.module.css";
import Header from "@/reusable_sections/Header";
import HeroNarcotics from "./sections/HeroNarcotics";
import OperationsSplit from "./sections/OperationsSplit";
import NarcoticsInquiry from "./sections/NarcoticsInquiry";
import Footer from "@/reusable_sections/Footer";
export default function CqlNarcIdPage() {
  return <div>
      <Header />
      <HeroNarcotics />
      <OperationsSplit />
      <NarcoticsInquiry />
      <Footer />
    </div>;
}